import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { useGradYearVisibility } from '../hooks/use-grad-year-visibility';
import { capitalize } from 'lodash';
import { Eye as VisibleIcon, EyeSlash as HiddenIcon } from 'react-bootstrap-icons';

const GradYearToggle = ({
    gradYear
}) => {
    const {
        getGradYearLabel,
        toggleGradYearVisibility,
        getGradYearVisibility
    } = useGradYearVisibility();
    const isVisible = getGradYearVisibility(gradYear);
    const pluralLabel = capitalize((getGradYearLabel(gradYear) || {})?.plural || 'unknown');
    const title = `${isVisible ? `Hide` : `Show`} ${pluralLabel}`;
    const Icon = isVisible ? VisibleIcon : HiddenIcon;
    const backgroundColor = isVisible ? 'transparent' : 'rgba(0,0,0,0.1)';
    return (
        <Dropdown.Item
            onClick={() => toggleGradYearVisibility(gradYear, !isVisible)}
            title={title}
            style={{ backgroundColor }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px'}}>
            <Icon /> <span>{title} ({gradYear})</span>
            </div>
        </Dropdown.Item>
    )
}

export const GradeVisibilityDropdown = () => {
    const { gradYears, resetVisibility } = useGradYearVisibility();
    return (
        <DropdownButton
            variant="outline-secondary"
            title="Show / Hide"
            id="input-group-dropdown-2"
            align="end"
        >
            {gradYears.map(gradYear => (<GradYearToggle key={gradYear} gradYear={gradYear} />))}
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => resetVisibility()}>Show All</Dropdown.Item>
        </DropdownButton>
    );
};
